import productdata from "../../assets/localdb/productdata"
import { useParams } from "react-router-dom"
export default function index()
{
    let {productname} = useParams();

    return (<>
     <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card card-table">
                                    <div className="card-body">
                                        <div className="title-header option-title d-sm-flex d-block">
                                            <h5>Stock of {productname}</h5>
                                            <div className="right-options">
                                                <ul>
                                                  <li>
                                                        <a className="btn btn-solid" href={`/stockaddorupdate/${productname}`}>Add Stock</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="table-responsive">
                                                <table className="table all-package theme-table table-product" id="table_id">
                                                    <thead>
                                                        <tr>
                                                            <th>Batch no</th>
                                                            <th>Ignore expiry date</th>
                                                            <th>Qty</th>
                                                            <th>MF Date</th>
                                                            <th>Exp Date</th>
                                                             <th>Option</th>
                                                        </tr>
                                                    </thead>
    
                                                    <tbody>
    
                                                        {productdata().map((product,keynum)=>
                                                        
                                                        <tr key={keynum}>
                                                            <td>{keynum*20}</td>
                                                           
                                                            <td className="status-close">
                                                            <span>Active</span>
                                                            </td>
    
                                                            <td>{product.quantity}</td>
                                                            <td>23/05/2020</td>
                                                            <td>25/10/2030</td>
                                                        
                                                            <td>
                                                        <ul>
                                                            <li>
                                                                <a href="/stockdetails">
                                                                    <i className="ri-eye-line"></i>
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href="/stockaddorupdate">
                                                                    <i className="ri-pencil-line"></i>
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href="javascript:void(0)" data-bs-toggle="modal"
                                                                    data-bs-target="#exampleModalToggle">
                                                                    <i className="ri-delete-bin-line"></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>

                                                           
    
    
                                                        </tr>)}
    
    
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    </>)
}